var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 33,
    viewBox: "0 0 24 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6295 0.963554L6.378 0.404554C8.01762 -0.118696 9.76937 0.727929 10.4714 2.38218L11.8689 5.67768C12.4766 7.11255 12.1386 8.80093 11.0336 9.85068L7.95425 12.7724C8.14437 14.5209 8.73263 16.2418 9.71737 17.9351C10.6525 19.5733 11.9069 21.0072 13.4061 22.1519L17.1046 20.9169C18.5054 20.4506 20.0329 20.9884 20.8909 22.2511L22.8945 25.1923C23.8939 26.6613 23.7135 28.686 22.4736 29.9308L21.146 31.2649C19.8233 32.5925 17.9334 33.0752 16.1865 32.5292C12.059 31.2422 8.26788 27.4218 4.80662 21.0681C1.3405 14.7046 0.116875 9.30305 1.13737 4.87005C1.56637 3.00455 2.894 1.51768 4.6295 0.963554Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneicon);
export default __webpack_public_path__ + "static/media/phoneicon.9acd7967a01946e83c2987e855e73d12.svg";
export { ForwardRef as ReactComponent };